import React from 'react';

import { bemBlock } from '../../modules/bem';
import { Button, ButtonProps } from '../button/Button';
import { GlyphName, Icon, IconProps } from '../icon/Icon';

import './ToggleButton.less';

const block = bemBlock('n-toggle-button');

type ToggleButtonProps = Omit<ButtonProps<{}>, 'variant'> & {
  active?: boolean;
  glyph: GlyphName;
  glyphSize?: IconProps['size'];
};

export const ToggleButton = ({
  className,
  glyph,
  active,
  glyphSize,
  ...restProps
}: ToggleButtonProps) => {
  return (
    <Button
      variant={active ? 'primary' : 'basic'}
      className={block({ extra: [className] })}
      size="lg"
      square
      {...restProps}
    >
      <Icon size={glyphSize} glyph={glyph} />
    </Button>
  );
};
